import { default as de } from './i18n.de';
import { default as en } from './i18n.en';
import { default as es } from './i18n.es';
import { default as fr } from './i18n.fr';
import { default as he } from './i18n.he';
import { default as it } from './i18n.it';
import { default as nl } from './i18n.nl';

export default {
    de, //
    en,
    es,
    fr,
    he,
    it,
    nl,
};
